import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { DateRangeForm } from 'src/app/shared/custom-date-dialog/custom-date-dialog.component';

@Component({
  selector: 'date-range-filter',
  styleUrl: '../filtered-search-option.component.scss',
  template: `
    <mat-form-field
      class="filter-form"
      appearance="outline"
      (click)="$event.stopPropagation(); $event.preventDefault()"
      (keyup)="$event.stopPropagation(); $event.preventDefault()"
      [formGroup]="formGroup"
      [attr.data-test]="'filter-date-range'"
    >
      <mat-label>
        {{ 'Filter.Value' | translate: locale.language }}
      </mat-label>
      <mat-date-range-input [max]="today" [rangePicker]="picker">
        <input
          [attr.data-test]="'filter-date-range-start'"
          formControlName="start"
          matStartDate
          [placeholder]="'Filter.StartDate' | translate: locale.language"
        />
        <input
          [attr.data-test]="'filter-date-range-end'"
          formControlName="end"
          matEndDate
          [placeholder]="'Filter.EndDate' | translate: locale.language"
        />
      </mat-date-range-input>
      <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DateRangeFilterComponent {
  @Input() formGroup: FormGroup<DateRangeForm>;
  today = new Date();

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
